import React from 'react';
import ToggleSwitch from '../widgetsAndUtils/ToggleSwitch';
import GoButton from '../widgetsAndUtils/GoButton';
import HydrologyInfo from '../infoSections/HydrologyInfo';
import { useAppStateContext } from '../../hooks/useAppState';

export default function HydrologyControls() {
  const { bmpState, state, updateHydrologyState, updateMpiData, getDisplayLabel, getBmpTypeDisplayName, ANALYSIS_TYPE_LABELS } = useAppStateContext();
  

  const comparisonMode = state.hydrology.comparisonMode;
  const analysistype = bmpState.analysistype;

  // Handle GoButton hydrology results
  const handleHydrologySuccess = (data) => {
    updateHydrologyState({ indexData: {} });
    updateHydrologyState({ indexData: data.data });


    // Remove any existing Hydrology entry
    const filtered = state.mpiData.filter(a => a.analytename !== "Hydrology");
    
    // Find the selected BMP data (not comparison data)
    const selectedBmpData = data.data.index_summary.find(d => 
      typeof d.bmp === 'string' && !d.bmp.startsWith('Other')
    );

    
    // Add new Hydrology entry
    const hydrologyObj = {
      analytename: "Hydrology",
      priority: 1,
      score: selectedBmpData?.performance_index || data.data.index_summary[0]?.performance_index,
      weight: NaN,
      threshold: NaN
    };
    updateMpiData([...filtered, hydrologyObj]);
  };

  return (
    <>
      <HydrologyInfo />
      
      {/* Status and Go Button */}
      <div className="flex justify-center items-start w-full mt-8">
        <div className="w-full max-w-4xl bg-white rounded-xl shadow p-0 border border-gray-200">
          {/* Status Section */}
          <div className="px-6 py-4">
            <h3 className="text-md font-semibold mb-2">Hydrology Analysis:</h3>
            <div className="text-sm text-gray-600">
              <p>Current BMP selection:</p>
              <p className="mt-2"><strong>Analysis Type:</strong> {getDisplayLabel(bmpState.analysistype, ANALYSIS_TYPE_LABELS) || 'Not selected'}</p>
              {bmpState.analysistype === "individual" && (
                <>
                  <p><strong>Site Name:</strong> {bmpState.sitename || 'Not selected'}</p>
                  <p><strong>BMP Name:</strong> {bmpState.bmpname || 'Not selected'}</p>
                </>
              )}
              {bmpState.analysistype === "bmptype" && (
                <p><strong>BMP Type:</strong> {getBmpTypeDisplayName(bmpState.bmptype) || 'Not selected'}</p>
              )}
              {bmpState.analysistype === "treatmenttrain" && (
                <p><strong>Site Name:</strong> {bmpState.sitename || 'Not selected'}</p>
              )}
            </div>
          </div>

          {/* Go Button and Comparison Toggle */}
          <div className="flex items-center justify-between px-6 py-4 border-t">
            {analysistype === 'individual' && (
              <ToggleSwitch
                id="hydrology-comparison-toggle"
                checked={!!comparisonMode}
                onChange={e => updateHydrologyState({ comparisonMode: e.target.checked })}
                label="Show Comparison Data"
              />
            )}
            <GoButton 
                datatype="hydrology" 
                onSuccess={handleHydrologySuccess} 
                disabled={!analysistype || (analysistype === "individual" && (!bmpState.sitename || !bmpState.bmpname)) || 
                    (analysistype === "bmptype" && !bmpState.bmptype) || 
                    (analysistype === "treatmenttrain" && !bmpState.sitename) }
            />
          </div>
        </div>
      </div>
    </>
  );
} 